<div class="video-form">
  <h6 class="subtitle is-6">Video configuration</h6>
  <form novalidate (ngSubmit)="handleSubmit()" [formGroup]="form">
    <div class="field">
      <div class="control">
        <input
          type="text"
          class="input is-small"
          placeholder="Video URL"
          formControlName="link"
        />
      </div>
    </div>
    <div class="form-actions">
      <button type="submit" class="button is-light is-small">
        Ok
      </button>
    </div>
  </form>
</div>
